import { Component, Input } from "@angular/core";
import { Contracts } from "../../models/contracts";

@Component({
  standalone: false,
  selector: "app-license-details",
  templateUrl: "./license-details.component.html",
  styleUrls: ["./license-details.component.scss"],
})
export class LicenseDetailsComponent {
  @Input()
  contractDetails: Contracts = new Contracts();
}
